import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom'
import { IBreadcrumbItem } from './IBreadcrumbItem';
import { createPortal } from 'react-dom';

export const AppBreadcrumb = (props: {
  breadcrumb: IBreadcrumbItem[],
}) => {
  const breadcrumbElement = document.getElementById('eitum-breadcrumb');
  
  if (!breadcrumbElement) {
    return null;
  }

  return createPortal(
    <Breadcrumb color='white'>
      {props.breadcrumb.map((item, index) => (
        <BreadcrumbItem key={index}>
          <BreadcrumbLink fontSize='md' as={RouterLink} to={item.href}>{item.label}</BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>,
    breadcrumbElement
  );
}
